import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { auth } from '../firebase/config';
import { applyActionCode, reload, confirmPasswordReset } from 'firebase/auth';
import './EmailVerificationComplete.css';

const EmailVerificationComplete = () => {
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleEmailAction = async () => {
      try {
        // URLパラメータからactionCodeを取得
        const actionCode = searchParams.get('oobCode');
        const mode = searchParams.get('mode');
        
        if (!actionCode || (!mode || (mode !== 'verifyEmail' && mode !== 'resetPassword'))) {
          setStatus('error');
          setMessage('無効な認証リンクです。');
          return;
        }

        if (mode === 'verifyEmail') {
          // メール認証の処理
          await applyActionCode(auth, actionCode);
          
          // 現在のユーザー情報を更新
          if (auth.currentUser) {
            await reload(auth.currentUser);
          }
          
          setStatus('success');
          setMessage('メールアドレスの認証が完了しました！');

          // auth.currentUserは「このブラウザに元々ログインしていた誰か」でしかなく、
          // 今回認証したアカウント本人とは限らないため、それに基づく自動ログインはせず
          // 必ずログイン画面へ誘導する
          setTimeout(() => {
            navigate('/login');
          }, 3000);
          
        } else if (mode === 'resetPassword') {
          // パスワードリセットの処理
          // 新しいパスワードを入力させるため、パスワードリセット専用画面に遷移
          navigate('/password-reset', { 
            state: { 
              actionCode: actionCode 
            } 
          });
          return;
        }
        
      } catch (error) {
        console.error('Email verification error:', error);
        setStatus('error');
        
        switch (error.code) {
          case 'auth/expired-action-code':
            setMessage('認証リンクの有効期限が切れています。新しい認証メールをリクエストしてください。');
            break;
          case 'auth/invalid-action-code':
            setMessage('無効な認証リンクです。');
            break;
          case 'auth/user-disabled':
            setMessage('このアカウントは無効化されています。');
            break;
          default:
            setMessage('認証処理中にエラーが発生しました。');
        }
      }
    };

    handleEmailAction();
  }, [searchParams, navigate]);

  const handleLoginRedirect = () => {
    navigate('/login');
  };

  const handleRequestNewEmail = () => {
    navigate('/email-verification');
  };

  return (
    <div className="email-verification-complete-container">
      <div className="email-verification-complete-box">
        <img src="/img/tiny-identity.png" alt="Tiny Identity" className="email-verification-complete-logo" />
        <h1 className="email-verification-complete-app-title">Tiny Identity</h1>

        <div className="email-verification-complete-content">
          {status === 'loading' && (
            <>
              <div className="email-verification-complete-loading-icon">
                <img src="/img/cat.png" alt="読み込み中" className="email-verification-complete-loading-animation" />
              </div>
              <h2 className="email-verification-complete-title">メール認証を処理中...</h2>
              <p className="email-verification-complete-text">しばらくお待ちください。</p>
            </>
          )}
          
          {status === 'success' && (
            <>
              <div className="email-verification-complete-success-icon">
                <img src="/img/check.png" alt="成功" />
              </div>
              <h2 className="email-verification-complete-title">メールアドレスは確認済みです</h2>
              <p className="email-verification-complete-success-message">
                新しいアカウントでログインできるようになりました
              </p>
              <p className="email-verification-complete-redirect-message">
                {message}
                <br />
                自動的にログイン画面へ移動します...
              </p>

              <div className="email-verification-complete-action-buttons">
                <button
                  className="email-verification-complete-btn-primary"
                  onClick={() => navigate('/login')}
                >
                  ログインページへ
                </button>
              </div>
            </>
          )}
          
          {status === 'error' && (
            <>
              <div className="email-verification-complete-error-icon">
                <img src="/img/warning.png" alt="エラー" />
              </div>
              <p className="email-verification-complete-error-message">{message}</p>
              
              <div className="email-verification-complete-action-buttons">
                <button 
                  className="email-verification-complete-btn-primary"
                  onClick={handleLoginRedirect}
                >
                  ログインページへ
                </button>
                <button 
                  className="email-verification-complete-btn-outline"
                  onClick={handleRequestNewEmail}
                >
                  新しい認証メールを送信
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationComplete;
